<template>
  <div class="nft_list">
    <div>
      <div v-if="isConnected && nfts.length > 0" class="px-2 md:px-0">
        <div
          class="flex flex-col flex-wrap md:flex-row md:-mx-3 md:justify-start items-start mt-6 text-center"
        >
          <div
            class="md:w-1/4 w-4/5 p-3 md:px-3"
            v-for="nft in nfts"
            :key="nft.id"
          >
            <div
              class="rounded flex justify-center items-center border-0 p-4 pt-8 border-gray-900 flex-col shadow-lg bg-white bg-opacity-25 hover:border-blue-400 cursor-pointer"
            >
              <div class="flex w-full justify-between items-center"></div>

              <div class="flip-box">
                <div class="flip-box-inner">
                  <div class="flip-box-front relative">
                    <img
                      id="dropzone"
                      :src="nft.image_preview_url"
                      alt="Person"
                      class="object-contain m-auto mb-2 h-48"
                      style=""
                    />
                  </div>
                </div>
              </div>

              <p class="mb-4 text-xl flex flex-col text-center">
                <span class="text-sm font-light">NFT #{{ nft.token_id }} </span>
              </p>

              <div>
                <button
                  class="border-0 border-gray-900 bg-gray-900 bg-opacity-100 hover:text-gray-900 hover:bg-white text-white py-2 px-4 mb-4 text-md rounded-lg font-light shadow-md"
                  v-on:click="
                    register(
                      nft.asset_contract.address,
                      nft.token_id,
                      nft.asset_contract.schema_name
                    )
                  "
                >
                  Play with this NFT (90 $ROYAL)
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center text-2xl mt-10">
        You don't have any vNFTs yet. You can buy one on
        <a
          href="https://nft20.io/trade"
          target="_blank"
          class="underline hover:text-blue-400"
        >
          NFT20</a
        >.
      </div>
    </div>

    <ConnectWallet />
  </div>
</template>

<script>
import ConnectWallet from "@/components/ConnectWallet.vue";
import NFT from "@/components/NFT.vue";

export default {
  name: "MyNfts",
  components: { ConnectWallet, NFT },
  data: function () {
    return {
      nfts: [],
      isLoading: true,
      listSize: 0,
      loader: null,
      hasTokenApproval: false,
      hasNftApproval: false,
    };
  },
  methods: {
    register: async function (contract, id, schema) {
      window.confirm(
        "The first time this will require 3 txs. 1 to approve token spend, 1 to approve NFT transfer and 1 to register the NFT to play"
      );

      console.log(contract);
      if (!this.hasTokenApproval) {
        await this.approve();
      }

      let isErc1155 = false;
      let nftContract;
      if (schema == "ERC1155") {
        isErc1155 = true;
        nftContract = await this.$store.state.ERC1155(contract);
      } else {
        nftContract = await this.$store.state.ERC721(contract);
      }

      console.log("nftContract ", nftContract);
      console.log("hasnft approval ", this.hasNftApproval);

      this.hasNftApproval = await nftContract.methods
        .isApprovedForAll(
          this.$store.state.account,
          this.$store.state.contracts.Game
        )
        .call();

      console.log("hasnft approval ", this.hasNftApproval);

      if (!this.hasNftApproval) {
        await this.setApproalForAll(contract, schema);
      }

      //  uncomment this when ready
      let minetx = await this.$store.state.GameContract.methods
        .register(contract, id, isErc1155)
        .send({
          from: this.$store.state.account,
        });
    },

    fetchNFTS: async function () {
      if (this.$store.state.web3 == null) {
        return;
      }
      let account = this.$store.state.account;

      const call = `https://api.opensea.io/api/v1/assets?owner=${account}&limit=50&offset=0`;

      let nfts = await axios.get(call);
      this.nfts = nfts.data.assets;

      console.log(this.nfts);
    },

    approve: async function () {
      let max =
        "115792089237316195423570985008687907853269984665640564039457584007913129639935";
      let remove = "0";
      let approve = await this.$store.state.RoyalTokenContract.methods
        .approve(this.$store.state.contracts.Game, max)
        .send({
          from: this.$store.state.account,
        });
    },
    setApproalForAll: async function (nftAddress, schema) {
      let contract;
      if (schema == "ERC1155") {
        contract = await this.$store.state.ERC1155(nftAddress);
      } else {
        contract = await this.$store.state.ERC721(nftAddress);
      }
      await contract.methods
        .setApprovalForAll(this.$store.state.contracts.Game, true)
        .send({
          from: this.$store.state.account,
        });
    },
    init: async function () {
      this.hasTokenApproval =
        (
          await this.$store.state.RoyalTokenContract.methods
            .allowance(
              this.$store.state.account,
              this.$store.state.contracts.Game
            )
            .call()
        ).length >= 18;

      console.log("token approval", this.hasTokenApproval);
    },
  },
  mounted: function () {
    this.init();
  },
  beforeMount: function () {
    this.fetchNFTS();
  },
  watch: {
    isConnected: function () {
      this.fetchNFTS();
      this.init();
    },
  },
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
